import clsx from "clsx";
import { SearchField, Input, Button, Label } from "react-aria-components";
import type { Key } from "@react-types/shared";

import styles from "./search.module.css";

interface SearchProps {
  value: string;
  label?: string;
  "aria-label"?: string;
  autofocus?: boolean;
  className?: string;
  placeholder?: string;
  onChange: (id: Key) => void;
  onClear: (id: Key) => void;
  isDisabled?: boolean;
}

function noop() {}

function Search({
  value,
  label,
  autofocus = false,
  placeholder = "",
  className = "",
  onChange,
  onClear,
  isDisabled = false,
  "aria-label": ariaLabel,
}: SearchProps) {
  const ariaLabelProps = ariaLabel ? { "aria-label": ariaLabel } : {};
  return (
    <SearchField
      {...ariaLabelProps}
      isDisabled={isDisabled}
      data-testid="pallet-search"
      className={clsx(styles.textField, className)}
    >
      {label && (
        <Label data-testid="pallet-search-label" className={styles.label}>
          {label}
        </Label>
      )}
      <Input
        {...ariaLabelProps}
        data-testid="pallet-search-input"
        value={value}
        onChange={(ev) => (onChange ? onChange(ev.target.value) : noop())}
        autoComplete="off"
        placeholder={placeholder}
        autoFocus={autofocus}
        className={styles.input}
      />
      <Button onPress={() => onClear("")} className={styles.clearButton}>
        ✕
      </Button>
    </SearchField>
  );
}

export default Search;
